import React from "react";
import Link from "next/link";
import Layout from "~/components/Layout";
import { NestedList } from "~/components/styledComponents/NestedList";

const Agb = () => {
    return (
        (<Layout title="Sportision - AGB">
            <NestedList className="container">
                <h1 className="text-break">Nutzungsbedingungen</h1>
                <ol>
                    <li>
                        Gegenstand der Nutzungsbedingungen
                        <ol>
                            <li>
                                Die Sportision GmbH, Langenwiedenweg 121, 59457 Werl (nachfolgend „Portalbetreiber“
                                genannt) betreibt unter www.sportision.de eine Internetplattform (nachfolgend „das
                                Portal“ genannt), auf der der Portalbetreiber verschiede Dienste anbietet. Unter anderem
                                können sich interessierte Personen (nachfolgend auch Nutzer genannt) über sportliche
                                Dienstleistungen von verschiedenen Anbietern (nachfolgend auch Unternehmen genannt)
                                informieren und Anfragen an diese stellen (beide Parteien gemeinsam werden auch
                                Teilnehmer genannt). Das Portal bietet dabei den Unternehmen die Möglichkeit ihre
                                Dienstleistungen zu präsentieren und weitere Dienste auf dem Portal zu nutzen.
                            </li>
                            <li>
                                Als Unternehmen iSd Nutzungsbedingungen gelten dabei alle natürlichen oder juristischen
                                Personen oder rechtsfähige Personengesellschaften, die bei Abschluss eines
                                Rechtsgeschäfts in Ausübung ihrer gewerblichen oder selbständigen beruflichen Tätigkeit
                                handeln.
                            </li>
                            <li>
                                Die vorliegenden Nutzungsbedingungen regeln die Zurverfügungstellung der Dienste durch
                                den Portalbetreiber und die Nutzung dieser Dienste durch Sie als ordnungsgemäß
                                angemeldeten Teilnehmer.
                            </li>
                            <li>
                                Informationen zum Portalbetreiber erhalten Sie{" "}
                                <Link href="https://www.sportision.de/impressum">
                                    hier
                                </Link>
                                .
                            </li>
                        </ol>
                    </li>

                    <li>
                        Änderungen der Nutzungsbedingungen
                        <ol>
                            <li>
                                Der Portalbetreiber behält sich vor, diese Nutzungsbedingungen jederzeit mit Wirksamkeit
                                auch innerhalb der bestehenden Vertragsverhältnisse zu ändern. Über derartige Änderungen
                                wird der Portalbetreiber die Teilnehmer mindestens 30 Kalendertage vor dem geplanten
                                Inkrafttreten der Änderungen in Kenntnis setzen. Sofern diese nicht innerhalb von 30
                                Tagen ab Zugang der Mitteilung widersprechen und die Inanspruchnahme der Dienste auch
                                nach Ablauf der Widerspruchsfrist fortsetzen, gelten die Änderungen ab Fristablauf als
                                wirksam vereinbart. Im Falle Ihres Widerspruchs wird der Vertrag zu den bisherigen
                                Bedingungen fortgesetzt. In der Änderungsmitteilung wird der Portalbetreiber die
                                Teilnehmer auf ihr Widerspruchsrecht und auf die Folgen hinweisen.
                            </li>
                        </ol>
                    </li>
                    <li>
                        Anmeldevoraussetzungen und Registrierungsvorgang
                        <ol>
                            <li>
                                Um die Dienste auf dem Portal in Anspruch nehmen zu können, müssen die Teilnehmer mit
                                dem Portalbetreiber einen Nutzungsvertrag schließen, indem Sie diese Nutzungsbedingungen
                                akzeptieren. Die Teilnehmer müssen sich bei der Registrierung mit Ihrem Vor- und Zunamen
                                bzw. Firma und einer Sie zuordbaren E-Mail-Adresse anmelden. Des Weiteren müssen die
                                Teilnehmer ein Passwort angeben.
                            </li>
                            <li>
                                Minderjährigen Personen ist eine Anmeldung untersagt. Bei juristischen Personen ist
                                zusätzlich eine vertretungsberechtigte natürliche Person anzugeben. Der Teilnehmer
                                bestätigt mit seiner Registrierung, dass er volljährig ist und sämtliche Dienste und
                                Leistungen auf dem Portal rechtmäßig in Anspruch nehmen kann. Die während des
                                Anmeldevorgangs vom Portalbetreiber erfragten Kontaktdaten und sonstigen Angaben müssen
                                vollständig und korrekt angegeben werden.
                            </li>
                            <li>
                                Unternehmen, die sich auf dem Portal registrieren wollen, müssen zudem nachfolgende
                                Voraussetzungen erfüllen:
                                <ol>
                                    <li>
                                        Das Unternehmen bestätigt mit der Registrierung, dass es bzw. seine Mitarbeiter
                                        (i) über die Ausbildung und Erfahrung verfügen, die erforderlich sind, um die
                                        Dienstleistungen unter Beachtung der nach der Verkehrsauffassung üblichen
                                        Standards in der jeweiligen Sportart und ohne Gefährdung der Mitglieder
                                        erbringen zu können, (ii) dass sie im Rahmen der Dienstleistungen die in der
                                        Bundesrepublik Deutschland geltenden Gesetze sowie alle gegebenenfalls
                                        einschlägigen öffentlich-rechtlichen Bestimmungen beachten und (iii) dass sie
                                        über eine Haftpflichtversicherung verfügen, welche einen hinreichenden
                                        Versicherungsschutz für die unter Berücksichtigung der Verkehrsauffassung
                                        typischerweise mit der Dienstleistung verbundenen Haftungsrisiken bietet.
                                    </li>
                                    <li>
                                        Des Weiteren verpflichten sich die Unternehmen hinsichtlich der Angaben über
                                        ihre Dienstleistungen sowie ihre persönlichen Qualifikationen alle
                                        erforderlichen gesetzlichen Bestimmungen einzuhalten und evtl. durch Verbände,
                                        Vereine oder vergleichbare Organisationen und Interessenvertretungen
                                        vorgeschriebene Anforderungen selbst zu überwachen sowie für deren Richtigkeit
                                        einzustehen.
                                    </li>
                                </ol>
                            </li>
                            <li>
                                Nach Eingang der Anmeldung werden die Angaben der Teilnehmer vom Portalbetreiber auf
                                Vollständigkeit und Plausibilität geprüft. Sind die Angaben aus Sicht des
                                Portalbetreibers korrekt und bestehen aus dessen Sicht keine sonstigen Bedenken,
                                schaltet dieser den beantragten Zugang frei, indem er dem Teilnehmer innerhalb von drei
                                Werktagen eine E-Mail mit einem Aktivierungs-Link zusendet.
                            </li>
                            <li>
                                Sollte der Teilnehmer innerhalb von drei Werktagen nach Abschluss der Registrierung
                                keine Bestätigungs-E-Mail erhalten, gilt der Antrag als abgelehnt. In diesem Fall ist
                                kein Nutzungsvertrag mit dem Teilnehmer geschlossen worden. Der Portalbetreiber ist
                                nicht verpflichtet, Ihnen den Grund für das Nichtzustandekommen des Nutzungsvertrags
                                mitzuteilen.
                            </li>
                        </ol>
                    </li>
                    <li>
                        Information: Vertragssprache, Speicherung Ihrer Registrierungsdaten
                        <ol>
                            <li>Die Vertragssprache ist Deutsch.</li>
                            <li>
                                Ihre Registrierung mit Einzelheiten zum geschlossenen Nutzungsvertrag wird von uns
                                gespeichert. Die Nutzungsbedingungen schicken wir Ihnen per E-Mail zu, Sie können diese
                                aber auch nach Vertragsschluss jederzeit über unsere Webseite aufrufen.
                            </li>
                            <li>
                                Als registrierter Teilnehmer können Sie Einzelheiten zu der Registrierung über den
                                Login-Bereich einsehen.
                            </li>
                        </ol>
                    </li>
                    <li>
                        Information: Korrekturhinweis
                        <p>
                            Sie können Ihre Eingaben vor Abschluss der Registrierung jederzeit mit der Löschtaste
                            berichtigen. Den Anmeldevorgang können Sie auch jederzeit durch Schließen des
                            Browser-Fensters vollständig beenden.
                        </p>
                    </li>
                    <li>
                        Verantwortung für die Zugangsdaten
                        <ol>
                            <li>
                                Im Verlauf des Anmeldevorgangs werden Sie gebeten, ein Passwort anzugeben. Mit diesem
                                und der von Ihnen angegebenen E-Mail-Adresse können Sie sich nach Freischaltung des
                                Accounts anschließend einloggen.
                            </li>
                            <li>
                                Die Zugangsdaten einschließlich des Passworts sind von Ihnen geheim zu halten und
                                unbefugten Dritten nicht zugänglich zu machen.
                            </li>
                            <li>
                                Es liegt weiter in Ihrer Verantwortung sicher zu stellen, dass Ihr Zugang zu dem Portal
                                und die Nutzung der auf dem Portal zur Verfügung stehenden Dienste ausschließlich durch
                                Sie bzw. durch die von Ihnen bevollmächtigten Personen erfolgt. Steht zu befürchten,
                                dass unbefugte Dritte von Ihren Zugangsdaten Kenntnis erlangt haben oder erlangen
                                werden, ist der Portalbetreiber unverzüglich zu informieren.
                            </li>
                            <li>
                                Sie haften für jedwede Nutzung und/oder sonstige Aktivität, die unter Ihren Zugangsdaten
                                ausgeführt wird, nach den gesetzlichen Bestimmungen.
                            </li>
                        </ol>
                    </li>
                    <li>
                        Aktualisierung Ihrer Teilnehmerdaten
                        <p>
                            Sie sind dazu verpflichtet, Ihre Daten (einschließlich Ihrer Kontaktdaten) aktuell zu
                            halten. Tritt während der Dauer Ihrer Teilnahme eine Änderung der angegebenen Daten ein, so
                            haben Sie die Angaben unverzüglich auf dem Portal in Ihren persönlichen Einstellungen zu
                            korrigieren. Sollte Ihnen dies nicht gelingen, so teilen Sie uns Ihre geänderten Daten bitte
                            unverzüglich in Textform, also per E-Mail oder Telefax mit.
                        </p>
                    </li>
                    <li>
                        Laufzeiten/ Kündigung der Teilnahme
                        <ol>
                            <li>
                                Der Nutzungsvertrag läuft für unbestimmte Zeit und ist von jeder Partei mit eine
                                Kündigungsfrist von sechs Monaten ordentlich
                                kündbar. Die Kündigung bedarf der Textform, also z.B. per E-Mail oder Fax.
                            </li>
                            <li>
                                Mit Wirksamwerden der Kündigung endet das Vertragsverhältnis und der Teilnehmer darf den
                                Zugang nicht mehr nutzen. Der Portalbetreiber behält sich vor, den Benutzernamen sowie
                                das Passwort mit Wirksamwerden der Kündigung zu sperren.
                            </li>
                            <li>
                                Der Portalbetreiber ist berechtigt, mit Ablauf von 30 Kalendertagen nach Wirksamwerden
                                der Kündigung und nach Ablauf etwaiger gesetzlicher Vorhaltungsfristen sämtliche im
                                Rahmen Ihrer Teilnahme entstandenen Daten unwiederbringlich zu löschen.
                            </li>
                        </ol>
                    </li>
                    <li>
                        Angebot und Verfügbarkeit der Dienste
                        <ol>
                            <li>
                                Der Portalbetreiber stellt den Teilnehmern auf dem Portal je nachdem, ob es Nutzer oder
                                Unternehmen sind, unterschiedliche Dienste zur zeitlich befristeten Nutzung im Rahmen
                                des geschlossenen Nutzungsvertrags zur Verfügung. Diese Dienste können z. B. das
                                Verfügbarmachen von Daten, Beiträgen, Bild- und Tondokumenten, Informationen und
                                sonstigen Inhalten (nachfolgend zusammenfassend „Inhalte“ genannt) sein, weiter die
                                Möglichkeit, individuelle Profile anzulegen und mit anderen Teilnehmern durch das
                                Verfassen von persönlichen Mitteilungen in Kontakt zu treten. Als Teilnehmer willigen
                                Sie darin ein, dass Sie von anderen Teilnehmern Nachrichten erhalten und diese auch
                                kommerzielle Werbung enthalten kann. Inhalt und Umfang der Dienste bestimmen sich nach
                                den von Ihnen mit dem Portalbetreiber vereinbarten Leistungen, im Übrigen nach den
                                jeweils aktuell auf dem Portal verfügbaren Funktionalitäten.
                            </li>
                            <li>
                                Da die auf dem Portal zur Verfügung gestellten Dienste, sofern nicht ausdrücklich auf
                                deren Kostenpflichtigkeit hingewiesen wird, kostenlos sind, besteht ein Anspruch auf die
                                Nutzung der auf dem Portal verfügbaren Dienste nur im Rahmen der technischen und
                                betrieblichen Möglichkeiten beim Portalbetreiber. Der Portalbetreiber bemüht sich um
                                eine möglichst unterbrechungsfreie Nutzbarkeit seiner Dienste. Jedoch können durch
                                technische Störungen (wie z.B. Unterbrechung der Stromversorgung, Hardware- und
                                Softwarefehler, technische Probleme in den Datenleitungen) zeitweilige Beschränkungen
                                oder Unterbrechungen auftreten. Bei kostenpflichtigen Diensten bzw. Softwareanwendungen,
                                die auf dem Portal vom Anbieter angeboten werden, muss der Teilnehmer einen gesonderten
                                Vertrag zu den entsprechenden Konditionen schließen.
                            </li>
                            <li>
                                Zu den auf dem Portal verfügbaren Diensten können auch Dienste Dritter gehören, zu
                                welchen der Portalbetreiber lediglich den Zugang vermittelt. Für die Inanspruchnahme
                                derartiger Dienste – die jeweils als Dienste Dritter kenntlich gemacht sind – können von
                                diesen Nutzungsbedingungen abweichende oder zusätzliche Regelungen gelten, auf die der
                                Portalbetreiber Sie jeweils hinweisen wird.
                            </li>
                        </ol>
                    </li>
                    <li>
                        Änderungen von Diensten
                        <p>
                            Der Portalbetreiber ist jederzeit berechtigt, auf dem Portal unentgeltlich bereitgestellte
                            Dienste zu ändern, neue Dienste unentgeltlich oder entgeltlich verfügbar zu machen und die
                            Bereitstellung unentgeltlicher Dienste einzustellen. Der Portalbetreiber wird hierbei
                            jeweils auf Ihre berechtigten Interessen Rücksicht nehmen.
                        </p>
                    </li>
                    <li>
                        Schutz der Inhalte, Verantwortlichkeit für Inhalte Dritter
                        <ol>
                            <li>
                                Die auf dem Portal verfügbaren Inhalte sind überwiegend geschützt durch das Urheberrecht
                                oder durch sonstige Schutzrechte und stehen jeweils im Eigentum des Portalbetreibers,
                                der anderen Teilnehmer oder sonstiger Dritter, welche die jeweiligen Inhalte zur
                                Verfügung gestellt haben. Die Zusammenstellung der Inhalte als Solche ist ggf. geschützt
                                als Datenbank oder Datenbankwerk iSd. §§ 4 Abs. 2, 87a Abs. 1 UrhG. Sie dürfen diese
                                Inhalte lediglich gemäß diesen Nutzungsbedingungen sowie im auf dem Portal vorgegebenen
                                Rahmen nutzen.
                            </li>
                            <li>
                                Die auf dem Portal verfügbaren Inhalte stammen teilweise vom Portalbetreiber und
                                teilweise von anderen Teilnehmern bzw. sonstigen Dritten. Inhalte der Teilnehmer sowie
                                sonstiger Dritter werden nachfolgend zusammenfassend „Drittinhalte“ genannt. Der
                                Portalbetreiber führt bei Drittinhalten keine Prüfung auf Vollständigkeit, Richtigkeit
                                und Rechtmäßigkeit durch und übernimmt daher keinerlei Verantwortung oder Gewährleistung
                                für die Vollständigkeit, Richtigkeit, Rechtmäßigkeit und Aktualität der Drittinhalte.
                                Dies gilt auch im Hinblick auf die Qualität der Drittinhalte und deren Eignung für einen
                                bestimmten Zweck, und auch, soweit es sich um Drittinhalte auf verlinkten externen
                                Webseiten handelt. Sämtliche Inhalte auf dem Portal sind Drittinhalte, ausgenommen
                                diejenigen Inhalte, die mit einem Urheberrechtsvermerk des Portalbetreibers versehen
                                sind.
                            </li>
                        </ol>
                    </li>
                    <li>
                        Umfang der erlaubten Nutzung, Überwachung der Nutzungsaktivitäten
                        <ol>
                            <li>
                                Ihre Nutzungsberechtigung beschränkt sich auf den Zugang zu dem Portal sowie auf die
                                Nutzung der auf dem Portal jeweils verfügbaren Dienste im Rahmen der Regelungen dieser
                                Nutzungsbedingungen.
                            </li>
                            <li>
                                Für die Schaffung der in Ihrem Verantwortungsbereich zur vertragsgemäßen Nutzung der
                                Dienste notwendigen technischen und rechtlichen Voraussetzungen sind Sie selbst
                                verantwortlich. Der Portalbetreiber schuldet Ihnen keine diesbezügliche Beratung.
                            </li>
                            <li>
                                Der Portalbetreiber weist darauf hin, dass Ihre Nutzungsaktivitäten im gesetzlich
                                zulässigen Umfang überwacht werden können. Dies beinhaltet ggf. auch die Protokollierung
                                von IP-Verbindungsdaten und Gesprächsverläufen sowie deren Auswertungen bei einem
                                konkreten Verdacht eines Verstoßes gegen die vorliegenden Nutzungsbedingungen und/oder
                                bei einem konkreten Verdacht auf das Vorliegen einer sonstigen rechtswidrigen Handlung
                                oder Straftat.
                            </li>
                        </ol>
                    </li>

                    <li>
                        Erstellung von Benutzerprofilen
                        <ol>
                            <li>
                                Soweit als Funktionalität auf dem Portal verfügbar, können die Teilnehmer ein
                                Benutzerprofil anlegen und im Rahmen der vorliegenden Nutzungsbedingungen nach Ihren
                                Vorstellungen individuell gestalten. So können z.B. Unternehmen Angaben zu ihrer
                                Ausbildung bzw. der ihrer Mitarbeiter und ihrer Erfahrungen machen und ihr Profil um
                                eine selbst verfasste Kurzbeschreibung einschließlich von Texten, Kommentaren und
                                Bildern ergänzen. Bei der Erstellung eines solchen Nutzungsprofils sind unbedingt die
                                Bestimmungen der Ziff. 14 bis 16 zu beachten.
                            </li>
                            <li>
                                Der Portalbetreiber führt im Regelfall keine Überprüfung der Identität der Profilinhaber
                                und der Angaben in den Profilen durch. Der Portalbetreiber leistet daher keine Gewähr
                                dafür, dass es sich bei jedem Profilinhaber jeweils um die Person handelt, für die der
                                jeweilige Profilinhaber sich ausgibt.
                            </li>
                        </ol>
                    </li>

                    <li>
                        Einstellen von eigenen Inhalten
                        <ol>
                            <li>
                                Soweit als Funktionalität auf dem Portal verfügbar, dürfen Sie unter Beachtung der
                                nachfolgenden Regelungen Inhalte auf dem Portal einstellen und damit für Dritte
                                verfügbar machen.
                            </li>
                            <li>
                                Mit dem Einstellen von Inhalten räumen Sie dem Portalbetreiber jeweils ein
                                unentgeltliches und übertragbares Nutzungsrecht an den jeweiligen Inhalten ein,
                                insbesondere
                                <br />
                                zur Speicherung der Inhalte auf dem Server des Portalbetreibers sowie deren
                                Veröffentlichung, insbesondere deren öffentlicher Zugänglichmachung (z.B. durch Anzeige
                                der Inhalte auf dem Portal),
                                <br />
                                zur Bearbeitung und Vervielfältigung, soweit dies für die Vorhaltung bzw.
                                Veröffentlichung der jeweiligen Inhalte erforderlich ist, und
                                <br />
                                zur Einräumung von – auch entgeltlichen – Nutzungsrechten gegenüber Dritten an Ihren
                                Inhalten entsprechend Ziff. 15. Soweit Sie die von Ihnen eingestellten Inhalte wieder
                                von dem Portal herunternehmen, erlischt das uns vorstehend eingeräumte Nutzungs- und
                                Verwertungsrecht. Wir bleiben jedoch berechtigt, zu Sicherungs- und/oder Nachweiszwecken
                                erstellte Kopien aufzubewahren. Die den Teilnehmern an von Ihnen eingestellten Inhalten
                                bereits eingeräumten Nutzungsrechte bleiben ebenfalls unberührt.
                            </li>
                            <li>
                                Sie sind für die von Ihnen eingestellten Inhalte voll verantwortlich. Der
                                Portalbetreiber übernimmt keine Überprüfung der Inhalte auf Vollständigkeit,
                                Richtigkeit, Rechtmäßigkeit, Aktualität, Qualität und Eignung für einen bestimmten
                                Zweck. Sie erklären und gewährleisten gegenüber dem Portalbetreiber daher, dass Sie der
                                alleinige Inhaber sämtlicher Rechte an den von Ihnen auf dem Portal eingestellten
                                Inhalten sind, oder aber anderweitig berechtigt sind (z.B. durch eine wirksame Erlaubnis
                                des Rechteinhabers), die Inhalte auf dem Portal einzustellen und die Nutzungs- und
                                Verwertungsrechte nach dem vorstehenden Absatz (2) zu gewähren.
                            </li>
                            <li>
                                Beim Einstellen von Inhalten (wie z.B. bei Inseraten und der Inanspruchnahme des
                                Buchungssystems und der Veröffentlichung von Angeboten), sind ausschließlich die
                                Unternehmen für die Richtigkeit der gemachten Angaben und die Einhaltung der damit
                                einhergehenden gesetzlichen Bestimmungen verantwortlich. Diese haben insbesondere den
                                gesetzlichen Anforderungen an die Kennzeichnung der von Ihnen eingestellten Inhalte (wie
                                z.B. Anbieterkennung/ Impressum, Kennzeichnung als werbliche Anzeige) und den sonstigen
                                gesetzlichen Informationspflichten zu genügen (wie z.B. evtl. Bereitstellung einer
                                Datenschutzerklärung und Erfüllung fernabsatzrechtlichen Vorgaben). Eine diesbezügliche
                                Beratung seitens des Portalbetreibers ist nicht geschuldet.
                            </li>
                            <li>
                                Der Portalbetreiber behält sich das Recht vor, das Einstellen von Inhalten abzulehnen
                                und/oder bereits eingestellte Inhalte (einschließlich privater Nachrichten und
                                Gästebucheinträge) ohne vorherige Ankündigung zu bearbeiten, zu sperren oder zu
                                entfernen, sofern das Einstellen der Inhalte durch den Teilnehmer oder die eingestellten
                                Inhalte selbst zu einem Verstoß gegen Ziff. 16 geführt haben oder konkrete Anhaltspunkte
                                dafür vorliegen, dass es zu einem schwerwiegenden Verstoß gegen Ziff. 16 kommen wird.
                                Der Portalbetreiber wird hierbei jedoch auf Ihre berechtigten Interessen Rücksicht
                                nehmen und das mildeste Mittel zur Abwehr des Verstoßes gegen Ziff. 16 wählen.
                            </li>
                        </ol>
                    </li>
                    <li>
                        Nutzungsrecht an auf dem Portal verfügbaren Inhalten
                        <ol>
                            <li>
                                Soweit nicht in diesen Nutzungsbedingungen oder auf dem Portal eine weitergehende
                                Nutzung ausdrücklich erlaubt oder auf dem Portal durch eine entsprechende Funktionalität
                                (z.B. Download-Button) ermöglicht wird,
                                <br />
                                dürfen Sie die auf dem Portal verfügbaren Inhalte ausschließlich für den vertraglich
                                bestimmten Zweck online abrufen und anzeigen. Dieses Nutzungsrecht ist auf die Dauer
                                Ihrer vertragsgemäßen Teilnahme an dem Portal beschränkt;
                                <br />
                                ist es Ihnen untersagt, die auf dem Portal verfügbaren Inhalte ganz oder teilweise zu
                                bearbeiten, zu verändern, zu übersetzen, vorzuzeigen oder vorzuführen, zu
                                veröffentlichen, auszustellen, zu vervielfältigen oder zu verbreiten. Ebenso ist es
                                untersagt, Urhebervermerke, Logos und sonstige Kennzeichen oder Schutzvermerke zu
                                entfernen oder zu verändern.
                            </li>
                            <li>
                                Zum Herunterladen von Inhalten („Download“) sowie zum Ausdrucken von Inhalten sind Sie
                                nur berechtigt, soweit eine Möglichkeit zum Download bzw. zum Ausdrucken auf dem Portal
                                als Funktionalität (z.B. mittels eines Download-Buttons) zur Verfügung steht.
                            </li>
                            <li>
                                Ihre zwingenden gesetzlichen Rechte (einschließlich der Vervielfältigung zum privaten
                                und sonstigen eigenen Gebrauch nach § 53 UrhG) bleiben unberührt.
                            </li>
                        </ol>
                    </li>

                    <li>
                        Verbotene Aktivitäten
                        <ol>
                            <li>
                                Ihnen sind jegliche Aktivitäten auf bzw. im Zusammenhang mit dem Portal untersagt, die
                                gegen geltendes Recht verstoßen, Rechte Dritter verletzen oder gegen die Grundsätze des
                                Jugendschutzes verstoßen. Insbesondere sind Ihnen folgende Handlungen untersagt:
                                <br />
                                das Einstellen, die Verbreitung, das Angebot und die Bewerbung pornografischer, gegen
                                Jugendschutzgesetze, gegen Datenschutzrecht und/oder gegen sonstiges Recht verstoßender
                                und/oder betrügerischer Inhalte, Dienste und/oder Produkte;
                                <br />
                                die Verwendung von Inhalten, durch die andere Teilnehmer oder Dritte beleidigt oder
                                verleumdet werden;
                                <br />
                                die Nutzung, das Bereitstellen und das Verbreiten von Inhalten, Diensten und/oder
                                Produkten, die gesetzlich geschützt oder mit Rechten Dritter (z.B. Urheberrechte)
                                belastet sind, ohne hierzu ausdrücklich berechtigt zu sein.
                            </li>
                            <li>
                                Des Weiteren sind Ihnen auch unabhängig von einem eventuellen Gesetzesverstoß bei der
                                Einstellung eigener Inhalte auf dem Portal sowie bei der Kommunikation mit anderen
                                Teilnehmern (z.B. durch Versendung persönlicher Mitteilungen) die folgenden Aktivitäten
                                untersagt:
                                <br />
                                die Verbreitung von Viren, Trojanern und anderen schädlichen Dateien;
                                <br />
                                die Versendung von Junk- oder Spam-Mails sowie von Kettenbriefen;
                                <br />
                                die Verbreitung anzüglicher, anstößiger, sexuell geprägter, obszöner oder diffamierender
                                Inhalte bzw. Kommunikation sowie solcher Inhalte bzw. Kommunikation die geeignet
                                sind/ist, Rassismus, Fanatismus, Hass, körperliche Gewalt oder rechtswidrige Handlungen
                                zu fördern bzw. zu unterstützen (jeweils explizit oder implizit);
                                <br />
                                die Belästigung anderer Teilnehmer, z.B. durch mehrfaches persönliches Kontaktieren ohne
                                oder entgegen der Reaktion des anderen Teilnehmers sowie das Fördern bzw. Unterstützen
                                derartiger Belästigungen;
                                <br />
                                die Aufforderung anderer Teilnehmer zur Preisgabe von Kennwörtern oder personenbezogener
                                Daten für kommerzielle oder rechts- bzw. gesetzeswidrige Zwecke;
                                <br />
                                die Verbreitung und/oder öffentliche Wiedergabe von auf dem Portal verfügbaren Inhalten,
                                soweit Ihnen dies nicht ausdrücklich vom jeweiligen Urheber gestattet oder als
                                Funktionalität auf dem Portal ausdrücklich zur Verfügung gestellt wird.
                            </li>
                            <li>
                                Ebenfalls untersagt ist Ihnen jede Handlung, die geeignet ist, den reibungslosen Betrieb
                                des Portals zu beeinträchtigen, insbesondere die Systeme des Portalbetreibers übermäßig
                                zu belasten
                            </li>
                            <li>
                                Sollte Ihnen eine illegale, missbräuchliche, vertragswidrige oder sonstige unberechtigte
                                Nutzung des Portals bekannt werden, so wenden Sie sich bitte an info@sportision.de. Der
                                Portalbetreiber wird den Vorgang dann prüfen und ggf. angemessene Schritte einleiten.
                            </li>
                            <li>
                                Bei Vorliegen eines Verdachts auf rechtswidrige bzw. strafbare Handlungen ist der
                                Portalbetreiber berechtigt und ggf. auch verpflichtet, Ihre Aktivitäten zu überprüfen
                                und ggf. geeignete rechtliche Schritte einzuleiten. Hierzu kann auch die Zuleitung eines
                                Sachverhalts an die Staatsanwaltschaft gehören.
                            </li>
                        </ol>
                    </li>
                    <li>
                        Sperrung von Zugängen
                        <ol>
                            <li>
                                Der Portalbetreiber kann Ihren Zugang zu dem Portal vorübergehend oder dauerhaft
                                sperren, wenn konkrete Anhaltspunkte vorliegen, dass Sie gegen diese Nutzungsbedingungen
                                und/oder geltendes Recht verstoßen bzw. verstoßen haben, oder wenn der Portalbetreiber
                                ein sonstiges berechtigtes Interesse an der Sperrung hat. Bei der Entscheidung über eine
                                Sperrung wird der Portalbetreiber Ihre berechtigten Interessen angemessen
                                berücksichtigen.
                            </li>
                            <li>
                                Im Falle der vorübergehenden bzw. dauerhaften Sperrung sperrt der Portalbetreiber Ihre
                                Zugangsberechtigung und benachrichtigt Sie hierüber per E-Mail.
                            </li>
                            <li>
                                Im Falle einer vorübergehenden Sperrung reaktiviert der Portalbetreiber nach Ablauf der
                                Sperrzeit die Zugangsberechtigung und benachrichtigt Sie hierüber per E-Mail. Eine
                                dauerhaft gesperrte Zugangsberechtigung kann nicht wiederhergestellt werden. Dauerhaft
                                gesperrte Personen sind von der Teilnahme an dem Portal dauerhaft ausgeschlossen und
                                dürfen sich nicht erneut auf dem Portal anmelden.
                            </li>
                        </ol>
                    </li>
                    <li>
                        Datenschutz
                        <p>
                            Zu den Qualitätsansprüchen des Portalbetreibers gehört es, verantwortungsbewusst mit den
                            persönlichen Daten der Teilnehmer (diese Daten werden nachfolgend „personenbezogene Daten“
                            genannt) umzugehen. Die sich aus Ihrer Anmeldung auf dem Portal sowie aus der Nutzung der
                            verfügbaren Dienste ergebenden personenbezogenen Daten werden vom Portalbetreiber daher nur
                            gemäß der von Ihnen bei der Registrierung bestätigten{" "}
                            <Link href="https://www.sportision.de/datenschutz">
                                Datenschutzerklärung
                            </Link>{" "}
                            erhoben, gespeichert und verarbeitet. Dessen ungeachtet sind die Unternehmen dafür
                            verantwortlich, bei der Verarbeitung personenbezogener Daten die geltenden
                            datenschutzrechtlichen Bestimmungen, insb. die der DSGVO, einzuhalten und eine entsprechende
                            Datenschutzerklärung bei der Einstellung entsprechender Angebote bereitzuhalten.
                        </p>
                    </li>
                    <li>
                        Haftungsbeschränkung
                        <ol>
                            <li>
                                Sollten Ihnen durch die Nutzung von auf dem Portal unentgeltlich zur Verfügung
                                gestellten Diensten ein Schaden entstehen, so haftet der Portalbetreiber nur, soweit Ihr
                                Schaden aufgrund der vertragsgemäßen Nutzung der unentgeltlichen Inhalte und/oder
                                Dienste entstanden ist, und nur bei Vorsatz (einschließlich Arglist) und grober
                                Fahrlässigkeit des Portalbetreibers.
                            </li>
                            <li>
                                Im Rahmen der kostenpflichtigen Nutzung der Dienste auf dem Portal (einschließlich des
                                Abrufs von kostenpflichtigen Inhalten) durch Sie haftet der Portalbetreiber nach Maßgabe
                                der nachfolgenden Regelungen:
                                <ol>
                                    <li>
                                        Für Schäden, die durch den Portalbetreiber oder durch dessen gesetzlichen
                                        Vertreter, leitende Angestellte oder einfache Erfüllungsgehilfen vorsätzlich
                                        oder grob fahrlässig verursacht wurde, haftet der Portalbetreiber unbeschränkt.
                                    </li>
                                    <li>
                                        In Fällen der leicht fahrlässigen Verletzung von nur unwesentlichen
                                        Vertragspflichten haftet der Portalbetreiber nicht. Im Übrigen ist die Haftung
                                        des Portalbetreibers für leicht fahrlässig verursachte Schäden auf diejenigen
                                        Schäden beschränkt, mit deren Entstehung im Rahmen des jeweiligen
                                        Vertragsverhältnisses typischerweise gerechnet werden muss (vertragstypisch
                                        vorhersehbare Schäden). Dies gilt auch bei leicht fahrlässigen
                                        Pflichtverletzungen der gesetzlichen Vertreter, leitenden Angestellten bzw.
                                        einfachen Erfüllungsgehilfen des Portalbetreibers.
                                    </li>
                                    <li>
                                        Die vorstehende Haftungsbeschränkung gilt nicht im Falle von Arglist, im Falle
                                        von Körper- bzw. Personenschäden, für die Verletzung von Garantien sowie für
                                        Ansprüche aus Produkthaftung.
                                    </li>
                                </ol>
                            </li>
                        </ol>
                    </li>
                    <li>
                        Schlussbestimmungen
                        <ol>
                            <li>
                                Sofern in diesen Nutzungsbedingungen nicht ausdrücklich etwas anderes angegeben ist,
                                sind sämtliche Erklärungen, die im Rahmen der Teilnahme an dem Portal abgegeben werden,
                                in Schriftform oder per E-Mail abzugeben. Die E-Mail-Adresse des Portalbetreibers lautet
                                sales@sportision.de. Die postalische Anschrift des Portalbetreibers lautet Sportision
                                GmbH, Langenwiedenweg 121, 59457 Werl. Änderungen der Kontaktdaten bleiben vorbehalten.
                                Im Fall einer solchen Änderung wird der Portalbetreiber Sie hierüber in Kenntnis setzen.
                            </li>
                            <li>
                                Diese Nutzungsbedingungen unterliegen dem Recht der Bundesrepublik Deutschland unter
                                Ausschluss des UN-Kaufrechts (Convention of Contracts for the International Sales of
                                Goods, CISG).
                            </li>
                            <li>
                                Soweit Sie bei Abschluss des Vertrages Ihren Wohnsitz oder gewöhnlichen Aufenthalt in
                                Deutschland hatten und entweder zum Zeitpunkt der Klageerhebung verlegt haben oder Ihren
                                Aufenthaltsort zu diesem Zeitpunkt unbekannt ist, ist Gerichtsstand für alle
                                Streitigkeiten der Sitz unseres Unternehmens. Wenn Sie Ihren Wohnsitz oder gewöhnlichen
                                Aufenthalt nicht in einem Mitgliedsstaat der Europäischen Union haben, dann sind für
                                alle Streitigkeiten die Gerichte an unserem Sitz ausschließlich zuständig. Sollten Sie
                                sich als Kaufmann, juristische Person des öffentlichen Rechts oder als
                                öffentlich-rechtliches Sondervermögen auf unserem Portal registriert haben, wird für
                                alle Ansprüche, die sich aus oder aufgrund dieser Nutzungsbedingungen ergeben, unser
                                Geschäftssitz als ausschließlicher Gerichtsstand vereinbart.
                            </li>
                            <li>
                                Sollten einzelne Bestimmungen dieses Vertrages unwirksam sein oder den gesetzlichen
                                Regelungen widersprechen, so wird hierdurch der Vertrag im Übrigen nicht berührt. Die
                                unwirksame Bestimmung wird von den Vertragsparteien einvernehmlich durch eine
                                rechtswirksame Bestimmung ersetzt, welche dem wirtschaftlichen Sinn und Zweck der
                                unwirksamen Bestimmung am nächsten kommt. Die vorstehende Regelung gilt entsprechend bei
                                Regelungslücken.
                            </li>
                        </ol>
                    </li>
                </ol>
            </NestedList>
        </Layout>)
    );
};

export default Agb;
